import { render, staticRenderFns } from "./diagnose-history-module.vue?vue&type=template&id=1cb50382&"
import script from "./diagnose-history-module.vue?vue&type=script&lang=js&"
export * from "./diagnose-history-module.vue?vue&type=script&lang=js&"
import style0 from "./diagnose-history-module.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "diagnose-history-module.vue"
export default component.exports